import type { ProjectDetail } from "@/mocks/admin/projects";

type Address = ProjectDetail["fromAddress"];

type Props = {
  from: Address;
  to: Address;
  distance: number;
};

export default function AddressCard({ from, to, distance }: Props) {
  const Pin = ({ a, type }: { a: Address; type: "origin" | "destination" }) => (
    <div className="flex items-start gap-3">
      <div className="flex flex-col items-center pt-1">
        <div
          className={`w-7 h-7 rounded-full flex items-center justify-center ${
            type === "origin" ? "bg-brand-100 text-brand-700" : "bg-emerald-100 text-emerald-700"
          }`}
        >
          <i className={type === "origin" ? "ri-map-pin-line" : "ri-flag-line"}></i>
        </div>
        {type === "origin" && (
          <div className="w-px flex-1 mt-1 bg-ink-200 border-l border-dashed h-12"></div>
        )}
      </div>
      <div className="flex-1 min-w-0 pb-1">
        <div className="text-[10px] font-bold uppercase tracking-wider text-ink-400">{a.label}</div>
        <div className="text-sm font-semibold text-ink-900 mt-0.5">
          {a.line1}
          {a.line2 ? `, ${a.line2}` : ""}
        </div>
        <div className="text-xs text-ink-500">
          {a.city}, {a.state} {a.zip}
        </div>
        <div className="mt-1.5 inline-flex items-start gap-1.5 text-[11px] text-amber-700 bg-amber-50 px-2 py-1 rounded-md">
          <i className="ri-information-line mt-0.5"></i>
          <span>{a.accessNotes}</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-base font-bold text-ink-900">Route</h3>
        <button className="inline-flex items-center gap-1 text-xs font-semibold text-brand-600 hover:text-brand-700 cursor-pointer">
          <i className="ri-external-link-line"></i>
          Open in Maps
        </button>
      </div>

      <div className="mb-4">
        <Pin a={from} type="origin" />
        <Pin a={to} type="destination" />
      </div>

      <div className="grid grid-cols-3 gap-2 pt-4 border-t border-ink-100 text-center">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Distance</div>
          <div className="font-display text-lg font-bold text-ink-900">{distance} mi</div>
        </div>
        <div className="border-x border-ink-100">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Drive</div>
          <div className="font-display text-lg font-bold text-ink-900">38 min</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Tolls</div>
          <div className="font-display text-lg font-bold text-ink-900">$0</div>
        </div>
      </div>
    </div>
  );
}